import { render, staticRenderFns } from "./interviewDetail.vue?vue&type=template&id=0c92e4c9&scoped=true"
import script from "./interviewDetail.vue?vue&type=script&lang=ts"
export * from "./interviewDetail.vue?vue&type=script&lang=ts"
import style0 from "./interviewDetail.vue?vue&type=style&index=0&id=0c92e4c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c92e4c9",
  null
  
)

export default component.exports